import { render } from "./user_reporting_modal.vue?vue&type=template&id=48df3267"
import script from "./user_reporting_modal.js?vue&type=script&lang=js"
export * from "./user_reporting_modal.js?vue&type=script&lang=js"

import "./user_reporting_modal.vue?vue&type=style&index=0&id=48df3267&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__